import { makeAutoObservable } from 'mobx';

class SuggestionViewModel {
  selected = false;
  data;

  constructor(data) {
    makeAutoObservable(this);

    this.data = data;
  }
}

export default SuggestionViewModel;
